import React from 'react';
import { PlayIcon, QuoteIcon, StarIcon } from 'lucide-react';
import type { Review, VideoTestimonial } from '../../types/content';
import { useShowSlotLabels } from '../../contexts/ImageSlotContext';
export function Stars({
  count = 5,
  className = 'h-4 w-4'
}: {
  count?: number;
  className?: string;
}) {
  return <span className="flex gap-0.5" aria-label={`${count} out of 5 stars`} role="img" data-id="element-507" data-mp="2f73zebg4xgfn">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className={`${className} fill-accent text-accent`} aria-hidden="true" data-id="element-508" data-mp="3bu8wv4z5w6hh" data-mpi={i} />)}
    </span>;
}
export function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <figure className="flex h-full flex-col rounded-[4px] bg-white p-6 ring-1 ring-navy/10 lg:p-8" data-id="element-509" data-mp="32xrkxziz44ko">
      <div className="flex items-center justify-between" data-id="element-510" data-mp="2xyofwf2ztycp">
        <Stars count={review.rating} data-id="element-511" data-mp="1rhjdpkslk52o" />
        <QuoteIcon className="h-7 w-7 text-chrome-300" aria-hidden="true" data-id="element-512" data-mp="1ref4ua46sl5o" />
      </div>
      <blockquote className="mt-5 text-[17px] leading-relaxed text-ink" data-id="element-513" data-mp="1mg3vs1lpueoi">“{review.quote}”</blockquote>
      <figcaption className="mt-auto border-t border-navy/10 pt-5" data-id="element-514" data-mp="2e04sjblo2fs0">
        <span className="block font-display text-lg font-semibold uppercase text-navy" data-id="element-515" data-mp="2ixdfrqlo9a04">{review.name}</span>
        <span className="text-sm text-steel" data-id="element-516" data-mp="24xvmoz1cfaky">{review.course}</span>
      </figcaption>
    </figure>;
}
export function VideoReviewCard({
  video
}: {
  video: VideoTestimonial;
}) {
  const showLabels = useShowSlotLabels();
  return <figure className="flex h-full flex-col overflow-hidden rounded-[4px] bg-navy ring-1 ring-navy/10" data-video-slot={video.slot} data-id="element-517" data-mp="1v6ra25z541ta">
      <div className="brushed relative flex aspect-video items-center justify-center" data-id="element-518" data-mp="1m8pazvyyvj8n">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-accent text-white" data-id="element-519" data-mp="1q9hkmqbr3q5g">
          <PlayIcon className="ml-1 h-7 w-7 fill-white" aria-hidden="true" data-id="element-520" data-mp="1ca9fzhwtjptv" />
        </span>
        <span className="absolute bottom-3 left-3 rounded-sm bg-ink/80 px-2 py-1 text-xs text-chrome-100" data-id="element-521" data-mp="1h8t6lvmcxpsk">{video.slot}</span>
        {showLabels && <span className="absolute left-2 top-2 rounded-sm bg-ink/85 px-2 py-1 text-[11px] text-white" data-id="element-522" data-mp="3iz1sasy72s87">Slot: {video.slot}</span>}
      </div>
      <figcaption className="mt-auto p-5" data-id="element-523" data-mp="3e5p3oitimlfg">
        <span className="block font-display text-lg font-semibold uppercase text-white" data-id="element-524" data-mp="3a55a1p85hzy2">{video.name}</span>
        <span className="text-sm text-chrome-300" data-id="element-525" data-mp="357wm180bn1ow">{video.course}</span>
      </figcaption>
    </figure>;
}